<template>
  <div class="com-page" v-wechat-title="this.title">
     <div class="comPage-compere">
        <spliteLight></spliteLight>
        <div class="topCon">
              <div class="comMessage">
                <div class="comImg">
                  <img :src="compereMsg.avatar" alt=""> 
              
                </div>
                <div class="comMsg">
                
                    <p class="comname">{{compereMsg.nickname}}</p>
                    <p class="sexAdd">
                      <img v-show="sex=='f'" src="../../assets/woman.png" alt="">
                      <img v-show="sex=='m'" src="../../assets/man.png" alt="">
                      <button class="add">
                      {{compereMsg.city}}
                      </button>
                    <button class="add add1">
                    {{compereMsg.constellation}}
                    </button>
                    </p>
                    <!-- <p class="introce">{{compereMsg.job}}</p> -->
                    <div class="attFens">
                      <span class="attentionNum">{{stars | peopleNumber}}</span>
                      <span v-if="stars.length>=5" style="font-size:0.25rem;color:rgba(102,102,102,1);">w</span>
                      <font class="att-font">关注</font>

                        <i></i>
                        <span class="fensNum">{{fans | peopleNumber}}</span>
                        <span v-if="fans.length>=5" style="font-size:0.25rem;color:rgba(102,102,102,1);">w</span>
                        <font class="fens-font">粉丝</font>
                    </div>
                </div>
              </div>
              <div class="addMsg">
                <div class="radioName">
                  <font>电台：</font>
                  <span>{{radioName}}</span>     
                </div>
                <div class="channelName">
                  <font>频率：</font>
                  <span>{{channelName}}</span>
                  <img src="../../assets/right1.png" alt="">     
                </div>
                <div class="pName">
                  <font>节目：</font>
                  <span  v-for="(item,index) in pName" :key="index"> {{item.title}} </span>
                  <img src="../../assets/right1.png" alt="">                    
                </div>


              </div>
        </div>
        <div class="boldLine"></div>
        <div class="downloadApp" @click="toDownloadpage">
          <p>
            <img src="../../assets/downNew.png" alt="">
          </p>
        </div>
    <spliteBold></spliteBold>
    <hotRecommendBold ></hotRecommendBold>
    <programcommenNew :commenProgram='recommendRecorded'></programcommenNew>
    </div>
     
    <myfooter></myfooter>
     <toast :msg="msg" ></toast>
  </div>
</template>

<script>
import  myfooter from '../commen/myfooter'
import  spliteBold from '../commen/spliteBold'
import  spliteLight from '../commen/spliteLight'
import  cbct from '../../../static/js/base.js'
import  toast from '../commen/toast.vue'
import  router from '../../router'
import  qs from 'qs'
import hotRecommendBold from '../commen/hotRecommendBold'
import programcommenNew from '../commen/programcommenNew'

export default {
  name: 'share',
  props: {
  
  },
   data(){
    return {
     compereMsg:[],
     recommen1:[],
     recommen2:[],
     sex:[],
     iscur:0,
     msg:'',
     number:'',
     stars:'',
     fans:'',
     type:'',
     title:"",
     isPage:'的主页',
     appName:'-听见广播',
     radioName:'',
     channelName:'',
     pName:[],
     recommendRecorded:[],

    
    }
  },
 filters:{
      
     peopleNumber:function(n1){
      if (n1!="") {
          let strNum="";
        if (n1.length>=5) {
           strNum=(parseFloat(n1/10000).toFixed(1))
         }else{
           strNum=n1
          }  
         return strNum  
         
         }   
     }
  },
  created(){
    let self=this
    if(self.$route.query.number){
     self.number=self.$route.query.number;
    }
    if(self.$route.query.hoster_id){
      self.number=self.$route.query.hoster_id;
    }
    self.type=self.$route.query.type;
    // self.bus.$emit('loading',true);
    self.$api.post(cbct.baseurl+"share/home-page",qs.stringify(
        {'number':this.number,
        'type':this.type,
        }
      )).then(function(res){
      // self.bus.$emit('loading',false);
     if (res.c==cbct.code.successCode) {
        self.compereMsg=res.d.info;
        self.sex=res.d.info.gender;
        self.stars=res.d.info.stars;
        self.fans=res.d.info.fans;
        self.title=res.d.info.nickname+self.isPage+self.appName;
        self.radioName=res.d.info.radio_name;
        self.channelName=res.d.info.channel_name;
        if (res.d.info.programme.length!=0) {
         self.pName=res.d.info.programme;     
        }
        if(res.d.recommend.length>0) {
              self.recommendRecorded=res.d.recommend;
        }else if(res.d.recommend.length==0){
          self.recommendRecorded=['none'];
        }
       
     }else{
       self.bus.$emit('toast',{show:true,title:res.m})

     }   
   }).catch((res)=>{
    //  console.log(res);
       
   });
  },
  methods:{
    toDownloadpage(){//点击下载
      this.$router.push({path:"downloadApp?isFrom=programRecorded"});
    },
  
    
  },

  components: {

       myfooter,
       spliteBold,
       spliteLight,
       toast,
       programcommenNew,
       hotRecommendBold
  },
  

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li{
  list-style: none;
}
.downloadApp{
box-sizing: border-box;
}
.downloadApp p{
  height: 0.76rem;
  width: 4.4rem;
  margin:0.35rem auto 0.34rem;

}
.downloadApp p img{
  width: 100%;
  height: 100%;
}
.addMsg{
   box-sizing: border-box;
   padding: 0.2rem 0 0.88rem;
   /* border: solid 1px;  */
   font-size: 0.24rem;
   text-align: left;
}
.addMsg div{
  margin-bottom: 0.18rem;
  color: rgba(49, 49, 49, 1);
  font-size: 0.28rem;
  overflow: hidden;
}
.addMsg div font{
  width: 0.82rem;
}
.addMsg div img{
  width: 0.22rem;
  vertical-align: middle;
  float: right;
}
.boldLine{
  height: 0.2rem;
  background: rgba(248, 248, 248, 1)
}


.com-page{
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
} 
.comPage-compere{
   width: 100%;
}
.topCon{
   width: 100%;
  box-sizing: border-box;
  padding: 0rem 0.5rem;
}
.comMessage{
  width: 100%;
  box-sizing: border-box;
  padding: 0.36rem 0rem;
  display: flex;
  align-items: center;
  border-bottom: solid 0.01rem rgba(221,221,221,1)


}
.comImg{
  width: 1.45rem;
  height: 1.44rem;
  margin-top: 0.14rem;
  vertical-align: middle;
}
.comImg>img{
  width: 100%;
  height: 100%;
  border-radius: 100%;
}
.comMsg{
  width: 2.92rem;
  margin-left: 0.36rem;
  text-align: left;
  /* line-height: 0.25rem; */
}
.comMsg>.comname{
  /* height: 0.35rem; */
  color: rgba(34, 34, 34);
  letter-spacing: 20; 
  font-size: 0.4rem;
}
.sexAdd{
  margin: 0.24rem 0 0.25rem;
  display: flex;
  align-items: center;
}
.sexAdd img{
 width: 0.28rem;
 height: 0.28rem;
}
.sexAdd .add{
  margin-left: 0.12rem;
  border: 0;
  border: solid 1px rgba(252,204,100,1);
  border-radius: 0.05rem;
  text-align: center;
  font-size: 0.2rem;
  font-weight:500;
  color:rgba(69,27,41,1);
  background:rgba(252,204,100,1);
  height: 0.3rem;
  line-height: 0.3rem;
  padding: 0 0.12rem;

}
.sexAdd .add1{
  border: solid 1px #333333;
  color: #333;
  background: white;


}
.introce{
  margin-top: .25rem;
    height: .23rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: .24rem;
    font-weight: 400;
    color: #333;
}
.attFens{
  /* margin-top: 0.23rem; */
  height: 0.2rem;
  line-height:0.2rem;
  font-weight:400;
  display: flex;
  align-items: center;
}
.attentionNum,.fensNum{
  font-size:0.255rem;
  color:rgba(102,102,102,1);
}

.att-font,.fens-font{
  font-size:0.21rem;
  color:rgba(153,153,153,1);
}
.att-font{
 margin: 0 0.17rem 0 0.18rem;
}
.fensNum{
margin: 0 0.16rem 0 0.14rem;

}
.programOrlife{
margin:0.58rem auto 0.56rem;
display: flex;
justify-content: center;
align-items: center;
}
.programOrlife li{
 width: 3.51rem;
 text-align: center;
 font-size:0.3rem;
 font-weight:500;
 padding-bottom: 0.16rem;
 border-bottom: solid 0.04rem rgba(153, 153, 153, 1);
  color: rgba(153, 153, 153, 1)
}

li.active
{
  color:rgba(253,16,49,1);
  border-bottom: solid 0.04rem rgba(253,16,49,1);
}





</style>
